import { render, staticRenderFns } from "./VorlagePromotionsstrukturNotensektion.vue?vue&type=template&id=37d52608"
import script from "./VorlagePromotionsstrukturNotensektion.vue?vue&type=script&lang=js"
export * from "./VorlagePromotionsstrukturNotensektion.vue?vue&type=script&lang=js"
import style0 from "./VorlagePromotionsstrukturNotensektion.vue?vue&type=style&index=0&id=37d52608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports